import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-unselected-warning',
  templateUrl: './unselected-warning.component.html'
})
export class UnselectedWarningComponent implements OnInit {
  deSelectedStudents: string[] = [];
  retValUnselectWarning: string;
  constructor(
    public dialogRef: MatDialogRef<UnselectedWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.deSelectedStudents = this.data.object;
  }
  backClick() {
    this.dialogRef.close();
  }
  continueClick() {
    this.retValUnselectWarning = 'Continue was clicked';
    this.dialogRef.close(this.retValUnselectWarning);
  }
}
